'use strict';

export default {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/defaults/transitional.js
// module id = 129
// module chunks = 14